import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import {
    AppBar, Button, Checkbox, CircularProgress, FormControlLabel, Grid, makeStyles, Typography, Link, Icon,
    Accordion, AccordionSummary, AccordionDetails
} from '@material-ui/core';

import { BasicConfirmDialog } from '../../../shared/components/BasicConfirmDialog';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { HomeContext } from '../../Home/HomeContext';
import { ErrorStatus } from '../../../shared/enum/ErrorStatus';
import { ClassificationModel, classificationModelInitial } from '../../../Models/ClassificationModel';
import { DetachedClassificationAction } from '../enum/DetachedClassificationAction';
import { VehicleModel } from '../../../Models/VehicleModel';
import InfluencerCompanyService from '../../../Services/InfluencerCompanyService';
import CompanyData, { validateCompanyData } from '../components/CompanyData';
import { CompanyModel } from '../../../Models/CompanyModel';
import InfluencerCompanyDataReputacao, { validarCampos } from '../components/InfluencerCompanyDataReputacao';
export interface INewsClassificationProps {
    spreadsheetId: number,
    influencerId: number,
    openList: boolean,
    setOpenList: (open: boolean) => void
}

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
    buttonsTop: {
        textTransform: 'initial',
        color: theme.palette.primary.main,
    },
    toolbar: {
        marginTop: '64px',
        padding: '8px',
        backgroundColor: '#F0F1F1',
    },
    loading: {
        minHeight: '80vh'
    },
    gridContainer: {
        marginTop: theme.spacing(5),
        overflow: 'hidden',
        // maxWidth: '100%',
        padding: theme.spacing(10)
    },
    gridContainerClient: {
        // maxWidth: '100%',
        padding: theme.spacing(3)
    },
    gridContainerText: {
        marginTop: '8px',
        // maxWidth: '100%',
        padding: theme.spacing(1),
        // height: 'calc(100vh - 100px)'
    },
    gridEditNews: {
        marginTop: theme.spacing(3)
    },
    text: {
        padding: theme.spacing(2)
    },
    clickHereText: {
        paddingBottom: theme.spacing(2)
    },
    clickHereLink: {
        textDecoration: 'underline',
        color: theme.palette.primary.dark,
        fontWeight: 'bold',
        '&:hover': {
            cursor: 'pointer'
        }
    }
}));

export default function CompanyClassification() {
    const classes = useStyles();

    const homeContext = React.useContext(HomeContext);
    const clientEnable = homeContext.influencerClientEnable;


    const [news, setNews] = React.useState<CompanyModel | null>(null);
    const [questions, setQuestions] = React.useState<any[]>([]);
    const [errorQuestions, setErrorQuestions] = React.useState<Record<string, any>>({});
    const [statusClassification, setStatusClassification] = React.useState<Record<string, any>>({});
    const [newsList, setNewsList] = React.useState<CompanyModel[]>([]);
    const [newsIndex, setNewsIndex] = React.useState<number>(0);
    const [newsCurrentId, setNewsCurrentId] = React.useState<number | null>(null);
    const [vehicle, setVehicle] = React.useState<VehicleModel | null>(null);
    const [vehicleMetricCorrect, setVehicleMetricCorrect] = React.useState<boolean>(false);
    const [errorDataStatus, setErrorDataStatus] = React.useState<ErrorStatus | null>(null);
    const [errorCategorizationStatus, setErrorCategorizationStatus] = React.useState<ErrorStatus | null>(null);
    const [errorAtLeastOneCategorizationStatus, setErrorAtLeastOneCategorizationStatus] = React.useState<ErrorStatus | null>(null);
    const [listNewsPending, setListNewsPending] = React.useState<CompanyModel[]>([]);
    const [keepData, setKeepData] = React.useState<boolean>(false);
    const [classification, setClassification] = React.useState<ClassificationModel | null>(null);
    const [tabListSelected, setTabListSelected] = React.useState<number>(0);
    const [detachedNewsDataAction, setDetachedNewsDataAction] = React.useState<DetachedClassificationAction | null>(null);
    const [detachedNewsCategorizationAction, setDetachedNewsCategorizationAction] = React.useState<DetachedClassificationAction | null>(null);

    const [openList, setOpenList] = React.useState<boolean>(true);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [showConfirmExit, setShowConfirmExit] = React.useState<boolean>(false);
    const [copyClassification, setCopyClassification] = React.useState<CompanyModel | null>(null);
    const [hasNotError, setHasNotError] = React.useState<boolean>(false);
    const [errorReputacao, setErrorReputacao] = React.useState<any>({});


    React.useEffect(() => {
        fetchInfluencer();
    }, [homeContext.spreadsheetId]);

    const fetchInfluencer = async () => {
        if (homeContext.spreadsheetId) {
            InfluencerCompanyService.getCompanyById(homeContext.spreadsheetId, { clientId: clientEnable?.id_cliente })
                .then((res: AxiosResponse) => {
                    setNews(res.data[0]);
                    setNewsCurrentId(res.data[0].id);
                })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
    };

    const handleClickSave = () => {
        // const hasBoardError = haStatusBoardError();
        const errosValidados = news ? validarCampos(news) : {};
        setErrorReputacao(errosValidados);
        const hasError = hasQuestionError() || hasCompanyDataError() || Object.keys(errosValidados).length > 0;

        if (!hasError) {
            return saveClassification();
        }
        else {
            return homeContext.showError('Ops.. existem campos com preenchimento inválido. Por favor, verifique os campos acima e tente novamente.');
        }
    };

    const hasCompanyDataError = () => {
        if (!news) return true;
        const errors = validateCompanyData(news);
        setErrorDataStatus(errors);
        return Object.keys(errors).length > 0;
    };


    const hasQuestionError = () => {
        const questionsdata = questions;
        const hasValue = questionsdata.find((question: any) => !question.value && question.tipo == 2);
        return hasValue;
    };




    const saveClassification = () => {
        if (news) {
            const clientId = clientEnable?.id_cliente;
            const updatedNews = { ...news, clientId };
            if (clientId) {

                InfluencerCompanyService.putClassificationCompany(clientId, updatedNews)
                    .then(() => {
                        homeContext.setOpenLoadingDialog(false);
                        // finishSaveAndCallNextNews();
                        homeContext.showSuccess('Empresa Salvo com Sucesso!');
                    })
                    .catch((error: AxiosError) => {
                        homeContext.setOpenLoadingDialog(false);
                        homeContext.showError('Erro ao atualizar Empresa. <br/>', error);
                    });
            }
        }
        return;
    };






    const getNewsToClassify = () => {
        return (
            <>
                {!loading
                    // && newsContext.listNewsPending.length > 0
                    && newsCurrentId
                    && newsCurrentId > 0 &&
                    <Grid
                        container
                        justify="center"
                        alignItems="center"
                        style={{ overflow: 'hidden' }}
                    >
                        <Grid
                            container
                            justify="center"
                            className={classes.gridContainer}
                            spacing={2}>
                            <Grid item xs={12} >
                                <Typography variant="h3" >
                                    Classificação de Empresas
                                </Typography>
                            </Grid>
                            <Grid
                                container
                                justify="space-between"
                                className={classes.gridContainerClient}
                                spacing={2}>
                                <Typography variant="h4" color="textSecondary">
                                    {news?.nome}
                                </Typography>
                            </Grid>
                            <Grid
                                container
                                spacing={3}
                                direction="column"
                                alignItems="stretch"
                                justify="center"
                                className={classes.root}>
                                <Accordion defaultExpanded>
                                    <AccordionSummary expandIcon={<Icon className={'material-icons-round'}>expand_more</Icon>}>
                                        <Typography variant="h5">Dados da Empresa</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <CompanyData news={news} setNews={setNews} setNewsCurrentId={setNewsCurrentId} newsCurrentId={newsCurrentId} />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            <Grid container
                                spacing={3}
                                direction="column"
                                alignItems="stretch"
                                justify="center"
                                className={classes.root}>
                                <Accordion defaultExpanded>
                                    <AccordionSummary expandIcon={<Icon className={'material-icons-round'}>expand_more</Icon>}>
                                        <Typography variant="h5">Categorização da Empresa</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <InfluencerCompanyDataReputacao news={news} setNews={setNews} setNewsCurrentId={setNewsCurrentId} newsCurrentId={newsCurrentId} />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            <Grid container
                                justifyContent="flex-end"
                                direction="row"
                                spacing={3}
                                style={{ marginTop: 24 }}
                            >
                                <Grid item xs={4}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleClickSave}
                                        size="large"
                                        fullWidth>
                                        {'CLASSIFICAR'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </>
        );
    };

    return (
        <>
            <AppBar position="fixed" className={classes.toolbar} color='inherit' elevation={0}>
                <Grid container justify={openList ? 'flex-start' : 'space-between'}>
                    <Button
                        className={classes.buttonsTop}
                        variant="text"
                        onClick={() => {
                            if (!loading && news && news.id > 0)
                                setShowConfirmExit(true);
                            else
                                homeContext.setPageLocation(PageLocation.INFLUENCER_COMPANY_LIST);
                        }}
                        startIcon={<Icon>arrow_back</Icon>}
                    >

                        Voltar para o histórico de Empresas
                    </Button>
                </Grid>
            </AppBar>
            {getNewsToClassify()}
            <BasicConfirmDialog
                title="Sair sem salvar?"
                description="Ao sair sem salvar, você perderá todos os dados de classificação já preenchidos para esta publicação."
                handleFirstButton={() => homeContext.setPageLocation(PageLocation.INFLUENCER_COMPANY_LIST)}
                handleSecondButton={() => setShowConfirmExit(false)}
                textFirstButton="SAIR"
                textSecondButton="Permanecer na página"
                cssProperties={{
                    maxWidth: '550px'
                }}
                open={showConfirmExit} />
        </>
    );
}